export default __webpack_public_path__ + "images/YV.25ffc0d.png";